<vivest-card variant="default" full-width data-testid="calendarizacao">
  <form class="calendarizacao" novalidate [formGroup]="form" (submit)="$event.preventDefault(); salvar()">
    <!-- Cada seção: ícone (ou o switch) na coluna da esquerda e o conteúdo à direita. -->
    <header class="calendarizacao__secao calendarizacao__secao--topo">
      <span class="calendarizacao__icone calendarizacao__icone--destaque" aria-hidden="true">
        <vivest-icon name="calendar" source="feather"></vivest-icon>
      </span>
      <div class="calendarizacao__conteudo">
        <h3 class="calendarizacao__titulo">Calendarização de notificações de prazos de adesão</h3>
        <p class="calendarizacao__descricao">
          Defina quando e como os participantes serão avisados do prazo de adesão aos institutos apresentados no
          extrato de desligamento.
        </p>
      </div>
    </header>

    <section class="calendarizacao__secao" aria-labelledby="calendarizacao-ativa-titulo">
      <span class="calendarizacao__icone">
        <vivest-switch
          formControlName="ativa"
          aria-labelledby="calendarizacao-ativa-titulo"
          aria-describedby="calendarizacao-ativa-descricao"
          data-testid="calendarizacao-ativa"
        ></vivest-switch>
      </span>
      <div class="calendarizacao__conteudo">
        <h4 id="calendarizacao-ativa-titulo" class="calendarizacao__subtitulo">Ativar notificações automáticas</h4>
        <p id="calendarizacao-ativa-descricao" class="calendarizacao__descricao">
          O sistema envia lembretes aos participantes elegíveis com base na data limite de adesão informada no extrato
          de desligamento.
        </p>
      </div>
    </section>

    <!-- Desligadas, prazos e canais ficam bloqueados (e apagados), sem perder o que foi escolhido. -->
    <fieldset
      class="calendarizacao__secao"
      [class.calendarizacao__secao--inativa]="!ativa()"
      formArrayName="prazos"
      aria-labelledby="calendarizacao-prazos-titulo"
      [attr.aria-describedby]="tentouSalvar() && erroPrazos() ? 'calendarizacao-prazos-erro' : 'calendarizacao-prazos-descricao'"
      data-testid="calendarizacao-prazos"
    >
      <span class="calendarizacao__icone" aria-hidden="true">
        <vivest-icon name="clock" source="feather"></vivest-icon>
      </span>
      <div class="calendarizacao__conteudo">
        <h4 id="calendarizacao-prazos-titulo" class="calendarizacao__subtitulo">Quando notificar o participante?</h4>
        <p id="calendarizacao-prazos-descricao" class="calendarizacao__descricao">
          Escolha com quantos dias de antecedência do vencimento do prazo de adesão o lembrete é enviado.
        </p>
        <div class="calendarizacao__opcoes">
          @for (dias of antecedencias; track dias; let i = $index) {
            <vivest-checkbox
              label-variant="multi-line"
              name="calendarizacao-prazos"
              [value]="dias"
              [formControlName]="i"
              [attr.data-testid]="'calendarizacao-prazo-' + dias"
            >
              {{ dias }} dias antes do vencimento
            </vivest-checkbox>
          }
        </div>
        @if (tentouSalvar() && erroPrazos()) {
          <p id="calendarizacao-prazos-erro" class="calendarizacao__erro" role="alert" data-testid="calendarizacao-prazos-erro">
            {{ erroPrazos() }}
          </p>
        }
      </div>
    </fieldset>

    <fieldset
      class="calendarizacao__secao"
      [class.calendarizacao__secao--inativa]="!ativa()"
      formArrayName="canais"
      aria-labelledby="calendarizacao-canal-titulo"
      [attr.aria-describedby]="tentouSalvar() && erroCanais() ? 'calendarizacao-canais-erro' : 'calendarizacao-canal-descricao'"
      data-testid="calendarizacao-canal"
    >
      <span class="calendarizacao__icone" aria-hidden="true">
        <vivest-icon name="send" source="feather"></vivest-icon>
      </span>
      <div class="calendarizacao__conteudo">
        <h4 id="calendarizacao-canal-titulo" class="calendarizacao__subtitulo">Canais de comunicação</h4>
        <p id="calendarizacao-canal-descricao" class="calendarizacao__descricao">
          Escolha por onde as notificações serão enviadas. Pode marcar mais de um canal.
        </p>
        <div class="calendarizacao__opcoes">
          @for (canal of canais; track canal.value; let i = $index) {
            <vivest-checkbox
              label-variant="multi-line"
              name="calendarizacao-canais"
              [value]="canal.value"
              [formControlName]="i"
              [attr.data-testid]="'calendarizacao-canal-' + canal.value"
            >
              {{ canal.label }}
            </vivest-checkbox>
          }
        </div>
        @if (tentouSalvar() && erroCanais()) {
          <p id="calendarizacao-canais-erro" class="calendarizacao__erro" role="alert" data-testid="calendarizacao-canais-erro">
            {{ erroCanais() }}
          </p>
        }
      </div>
    </fieldset>

    <!-- O que vai acontecer, em uma frase: muda junto com a tela. -->
    <p
      class="calendarizacao__resumo"
      [class.calendarizacao__resumo--inativo]="!ativa()"
      role="status"
      data-testid="calendarizacao-resumo"
    >
      <vivest-icon name="info" source="feather" aria-hidden="true"></vivest-icon>
      <span>
        <strong class="calendarizacao__resumo-titulo">Resumo da configuração</strong>
        {{ resumo() }}
      </span>
    </p>

    <footer class="calendarizacao__rodape">
      <vivest-button
        variant="outline"
        size="md"
        [disabled]="!temAlteracoes()"
        data-testid="calendarizacao-descartar"
        (click)="descartar()"
      >
        Descartar alterações
      </vivest-button>
      <vivest-button
        variant="primary"
        size="md"
        [disabled]="!temAlteracoes()"
        data-testid="calendarizacao-salvar"
        (click)="salvar()"
      >
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  </form>
</vivest-card>

<!-- Confirmação antes de salvar (vivest-modal do design system). -->
<vivest-modal
  heading="Salvar calendarização"
  description="Os lembretes passam a seguir esta configuração nos próximos extratos de desligamento. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="cancelarSalvar()"
  data-testid="calendarizacao-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="calendarizacao-confirmar-voltar" (click)="cancelarSalvar()">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="calendarizacao-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
